/* eslint-disable no-unused-vars */

'use strict';

var focusHelper = require('base/components/focus');
var base = require('../product/base');

var DOMPurify = window.DOMPurify;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return `${key}=${encodeURIComponent(params[key])}`;
            })
            .join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml =
                '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                `</button>${data.valid.message}</div>`;

            $('.cart-error').html(DOMPurify.sanitize(errorHtml));
        } else {
            $('.cart')
                .empty()
                .append(
                    DOMPurify.sanitize(
                        '<div class="row"> ' +
                            '<div class="col-12 text-center"> ' +
                            `<h1>${data.resources.emptyCartMsg}</h1> ` +
                            '</div> ' +
                            '</div>'
                    )
                );
            $('.number-of-items').empty().append(DOMPurify.sanitize(data.resources.numberOfItems));
            $('.minicart-quantity')
                .empty()
                .append(DOMPurify.sanitize(String(data.numItems)));
            $('.minicart-link').attr({
                'aria-label': DOMPurify.sanitize(data.resources.minicartCountOfItems),
                title: DOMPurify.sanitize(data.resources.minicartCountOfItems)
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
        $('.cart-error').empty();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(DOMPurify.sanitize(data.resources.numberOfItems));
    $('.shipping-cost').empty().append(DOMPurify.sanitize(data.totals.totalShippingCost));
    $('.sub-total').not('.receipt .sub-total').empty().append(DOMPurify.sanitize(data.totals.subTotal));
    $('.minicart-quantity')
        .empty()
        .append(DOMPurify.sanitize(String(data.numItems)));
    $('.minicart-link').attr({
        'aria-label': DOMPurify.sanitize(data.resources.minicartCountOfItems),
        title: DOMPurify.sanitize(data.resources.minicartCountOfItems)
    });

    if ($('.grand-total .grand-total-sum').not('.receipt .grand-total .grand-total-sum').length > 0) {
        $('.grand-total .grand-total-sum')
            .not('.receipt .grand-total .grand-total-sum')
            .empty()
            .append(DOMPurify.sanitize(data.totals.subTotal));
    } else {
        $('.grand-total').not('.receipt .grand-total').empty().append(DOMPurify.sanitize(data.totals.subTotal));
    }

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').not('.receipt .order-discount').removeClass('hide-order-discount');
        $('.order-discount-total')
            .not('.receipt .order-discount-total')
            .empty()
            .append(`- ${DOMPurify.sanitize(data.totals.orderLevelDiscountTotal.formatted)}`);
        $('.card-body').not('.receipt .card-body').removeClass('empty-card-body');
    } else {
        $('.order-discount').not('.receipt .order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').not('.receipt .shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total')
            .not('.receipt .shipping-discount-total')
            .empty()
            .append(`- ${DOMPurify.sanitize(data.totals.shippingLevelDiscountTotal.formatted)}`);
    } else {
        $('.shipping-discount').not('.receipt .shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.totals.totalSavings) {
        $('.order-savings').not('.receipt .order-savings').removeClass('hide-order-savings');
        $('.order-total-savings')
            .not('.receipt .order-total-savings')
            .empty()
            .append(DOMPurify.sanitize(data.totals.totalSavings));
        $('.product-discount').removeClass('hide-product-discount');
        $('.product-discount-total')
            .empty()
            .append(`- ${DOMPurify.sanitize(data.totals.totalSavings)}`);
        $('.card-body').not('.receipt .card-body').removeClass('empty-card-body');
    } else {
        $('.order-savings').not('.receipt .order-savings').addClass('hide-order-savings');
        $('.product-discount').addClass('hide-product-discount');
    }

    if (data.totals.undiscountedTotalPrice) {
        $('.order-subtotal').removeClass('hide-order-subtotal');
        $('.order-subtotal-price').empty().append(DOMPurify.sanitize(data.totals.undiscountedTotalPrice));
    } else {
        $('.order-subtotal').addClass('hide-order-subtotal');
    }

    var $taxItems = $('.sales-tax-item');
    if (data.totals.taxRates && data.totals.taxRates.length > 0) {
        var taxKeys = [];

        data.totals.taxRates.forEach(function (tax) {
            var taxItemId = `sales-tax-item-${tax.key}`;
            var $matchedTaxItem = $taxItems.filter(`#${$.escapeSelector(taxItemId)}`);

            taxKeys.push(taxItemId);
            if ($matchedTaxItem.length > 0) {
                $matchedTaxItem.find('.sales-tax-total').text(DOMPurify.sanitize(tax.value));
            }
        });

        $taxItems.each(function () {
            var taxId = $(this).attr('id');

            if (!taxKeys.includes(taxId)) {
                $(this).remove();
            }
        });

        $('.card-body').removeClass('empty-card-body');
    } else {
        $taxItems.remove();
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.totals.discountsHtml));
        }
        if (item.renderedPromotions) {
            $(`.item-${item.UUID}`)
                .not(`.receipt .item-${item.UUID}`)
                .empty()
                .append(DOMPurify.sanitize(item.renderedPromotions));
        } else {
            $(`.item-${item.UUID}`).not(`.receipt .item-${item.UUID}`).empty();
        }
        $(`.item-total-${item.UUID}`)
            .not(`.receipt .item-total-${item.UUID}`)
            .empty()
            .append(DOMPurify.sanitize(item.priceTotal.renderedPrice));
        $(`.minicart-item-total-${item.UUID}`)
            .empty()
            .append(DOMPurify.sanitize(item.priceTotal.minicartRenderedPrice));
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        `</button>${message}</div>`;

    $('.cart-error').append(DOMPurify.sanitize(errorHtml));
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += `<div class="single-approaching-discount text-center">${item.discountMsg}</div>`;
        });
    }
    $('.approaching-discounts').append(DOMPurify.sanitize(html));
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $(`.availability-${lineItem.UUID}`).empty();

        if (lineItem.availability && !lineItem.available) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += `<p class="line-item-attributes">${message}</p>`;
                });
            }

            if (lineItem.availability.inStockDate) {
                messages +=
                    '<p class="line-item-attributes line-item-instock-date">' +
                    `${lineItem.availability.inStockDate}</p>`;
            }
        }

        $(`.availability-${lineItem.UUID}`).html(DOMPurify.sanitize(messages));
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $(`.card.product-info.uuid-${uuid}`).replaceWith(DOMPurify.sanitize(data.renderedTemplate));
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append(DOMPurify.sanitize($.parseHTML(html)));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success(data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(DOMPurify.sanitize(data.closeButtonText));
            $('#editProductModal .enter-message').text(DOMPurify.sanitize(data.enterDialogMessage));
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Checks differences between the number of rendered product line items and the updated ones
 * to detect changes in bonus product line items.
 * Then updates the bonus product line item details in the UI
 * @param {Object} data - AJAX response from the server
 */
function updateBonusProductLineItems(data) {
    var $renderedProductLineItemsContainer = $('.product-line-items').not('.receipt .product-line-items');
    var $renderedProductLineItems = $renderedProductLineItemsContainer.children('.product-info, .product-line-item');
    var addedBonusPli = false;
    var removedBonusPli = false;

    if (
        data.items.length > 0 &&
        $renderedProductLineItemsContainer.length > 0 &&
        $renderedProductLineItems.length !== data.items.length
    ) {
        var productLineItemsKeys = [];

        data.items.forEach(function (item) {
            var pliId = item.UUID;
            var $matchedPliItem = $renderedProductLineItems.filter(function () {
                return $(this).hasClass(`uuid-${pliId}`) || $(this).data('product-line-item') === pliId;
            });

            productLineItemsKeys.push(pliId);
            if (!$matchedPliItem.length && data.bonusProductLineItemsHtml.length > 0) {
                var newBonusProductItem = data.bonusProductLineItemsHtml.find((elem) => elem.id === pliId);
                if (newBonusProductItem) {
                    $renderedProductLineItemsContainer.append(DOMPurify.sanitize(newBonusProductItem.html));
                    addedBonusPli = true;
                }
            }
        });

        $renderedProductLineItems.each(function () {
            var itemIdFromClass = Array.from(this.classList).find(function (cls) {
                return cls.startsWith('uuid-');
            });

            var itemId = itemIdFromClass ? itemIdFromClass.replace('uuid-', '') : $(this).data('product-line-item');

            if (itemId && !productLineItemsKeys.includes(itemId)) {
                $(this).remove();
                removedBonusPli = true;
            }
        });

        if ((addedBonusPli || removedBonusPli) && $renderedProductLineItemsContainer.find('.product-info').length > 0) {
            $renderedProductLineItems = $renderedProductLineItemsContainer.children();

            $renderedProductLineItems.each(function (index) {
                var isLast = index === $renderedProductLineItems.length - 1;

                if ($(this).hasClass('product-info')) {
                    var $hr = $(this).children('hr');

                    if (!isLast) {
                        if (!$hr.length) {
                            $(this).append('<hr>');
                        }
                        $(this).removeClass('mb-5');
                    } else {
                        if ($hr.length) {
                            $hr.remove();
                        }
                        if (!$(this).hasClass('mb-5')) {
                            $(this).addClass('mb-5');
                        }
                    }
                }
            });
        }
    }
}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = { pid: productID, uuid };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            success(data) {
                if (data.basket.items.length === 0) {
                    $('.cart.cart-page').addClass('d-none');
                    $('.cart-empty').removeClass('d-none');
                    $('.cart-header').empty();
                    $('.number-of-items').empty().append(DOMPurify.sanitize(data.basket.resources.numberOfItems));
                    $('.minicart-quantity')
                        .empty()
                        .append(DOMPurify.sanitize(String(data.basket.numItems)));
                    $('.minicart-link').attr({
                        'aria-label': DOMPurify.sanitize(data.basket.resources.minicartCountOfItems),
                        title: DOMPurify.sanitize(data.basket.resources.minicartCountOfItems)
                    });
                    $('.minicart .popover').empty().removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    $('.cart-error').empty();
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $(`.uuid-${data.toBeDeletedUUIDs[i]}`).remove();
                        }
                    }
                    $(`.uuid-${uuid}`).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.basket.totals.discountsHtml));
                    updateCartTotals(data.basket);
                    updateBonusProductLineItems(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = { pid: productID, quantity, uuid };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url,
            type: 'get',
            context: this,
            dataType: 'json',
            success(data) {
                var productQuantitySelector = $(`.quantity[data-uuid="${uuid}"]`);
                productQuantitySelector?.val(quantity);
                // Update the custom quantity selector input to trigger the component status update, but pass true as
                // the avoidUpdateQuantitySelector value to avoid entering an infinite loop
                productQuantitySelector
                    ?.siblings('.custom-quantity-selector__input')
                    ?.val(quantity)
                    .trigger('change', [true]);
                $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.totals.discountsHtml));
                updateCartTotals(data);
                updateBonusProductLineItems(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);
                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = { methodID: $(this).find(':selected').attr('data-shipping-id') };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success(data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.totals.discountsHtml));
                    updateCartTotals(data);
                    updateBonusProductLineItems(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error(err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.coupon-code-field').on('input', function () {
        if ($(this).val().length > 0) {
            $('.promo-code-btn').removeClass('disabled');
        } else {
            $('.promo-code-btn').addClass('disabled');
        }
    });

    $('.promo-code-btn').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('disabled')) {
            $('.promo-code-form').submit();
        }
    });

    $('.add-more-coupons > a').click(function (e) {
        e.preventDefault();
        $('.add-more-coupons').addClass('d-none');
        $('.promo-code-form-container').removeClass('d-none');
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success(data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(DOMPurify.sanitize(data.errorMessage));
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.totals.discountsHtml));
                    updateCartTotals(data);
                    updateBonusProductLineItems(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error(err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(DOMPurify.sanitize(couponCode));
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = { code: couponCode, uuid };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            success(data) {
                $(`.coupon-uuid-${uuid}`).remove();
                updateCartTotals(data);
                updateBonusProductLineItems(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error(err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success(data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error() {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer).closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order') ||
                !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(
                !response.product.available || !response.product.readyToOrder
                    ? DOMPurify.sanitize(response.message)
                    : ''
            );

        var dialog = $(response.$productContainer).closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog).data('ready-to-order', allReady).data('available', allAvailable);

            var availabilityText = '';
            if (allReady || !response.product.available) {
                availabilityText = response.message;
            } else if (!allReady) {
                availabilityText = response.resources.info_selectforstock;
            }
            $('.global-availability .availability-msg', dialog).empty().html(DOMPurify.sanitize(availabilityText));
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(
                    !response.product.available || !response.product.readyToOrder
                        ? DOMPurify.sanitize(response.message)
                        : ''
                );
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success(data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(DOMPurify.sanitize(data.cartModel.totals.discountsHtml));
                    updateCartTotals(data.cartModel);
                    updateBonusProductLineItems(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $(`.uuid-${data.uuidToBeDeleted}`).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('promotion:success', function (e, response) {
        if ($('.coupons-and-promos').children().length > 0) {
            $('.add-more-coupons').removeClass('d-none');
            $('.promo-code-form-container').addClass('d-none');
        } else {
            $('.add-more-coupons').addClass('d-none');
            $('.promo-code-form-container').removeClass('d-none');
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    base.availability();
};
